// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ripple[data-v-4550e417]{width:100%;border-radius:100%;padding-bottom:120%;transition:transform .4s ease .05s;transform:translate(-50%,-50%) scale(0);z-index:0;border:none}a[data-v-4550e417]{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-webkit-transform:translateZ(0);-moz-transform:translateZ(0)}a:hover .ripple[data-v-4550e417]{transform:translate(-50%,-50%) scale(1.2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
